import * as Yup from 'yup';
import useGetConcreteStructuresIds from '../../../shared/hooks/useGetConcreteStructuresIds';
const MIN_DIMENSIONS_PRODUCT = 67500;

const useFiltersValidationSchema = () => {
  const { beamOrientationId, columnOrientationId } = useGetConcreteStructuresIds();
  const validationSchema = Yup.object().shape({
    structuralElement: Yup.string().required('results.filters.required'),
    depth: Yup.number().when('structuralElement', {
      is: (value: number) =>
        Number(value) === beamOrientationId ||
        Number(value) === columnOrientationId,
      then: (schema) => schema.required('results.filters.required'),
      otherwise: (schema) => schema.notRequired()
    }).moreThan(0, 'concrete.errors.depth')
      .test({
        name: 'dimensions-product-validation',
        message: 'concrete.errors.dimensionsProduct',
        test: (value, depth) => {
          const widthValue = depth.parent.width;

          if (widthValue < 150 || !value) {
            return true;
          }

          const result = value * widthValue;

          return result >= MIN_DIMENSIONS_PRODUCT;
        },
      }),
    width: Yup.number().when('structuralElement', {
      is: (value: number) =>
        Number(value) === beamOrientationId ||
        Number(value) === columnOrientationId,
      then: (schema) => schema.required('results.filters.required'),
      otherwise: (schema) => schema.notRequired()
    }).min(150, 'concrete.errors.width')
      .test({
        name: 'dimensions-product-validation',
        message: 'concrete.errors.dimensionsProduct',
        test: (value, width) => {
          const depthValue = width.parent.depth;

          if (depthValue === 0 || !value) {
            return true;
          }

          const result = value * depthValue;

          return result >= MIN_DIMENSIONS_PRODUCT;
        },
      }),
    requiredAxis: Yup.number().required('results.filters.required').moreThan(0, 'concrete.errors.requiredAxis')
      .test({
        name: 'axis-comparison-validation',
        message: 'concrete.errors.axisComparison',
        test: (value, requiredAxis) => {
          const currentAxisValue = requiredAxis.parent.currentAxis ?? 0;
          if (value) {
            return currentAxisValue < value;
          }

          return true;
        },
      }),
    fireRating: Yup.string().required('fireRating.error'),
    wastage: Yup.number().required('environment.errors.wastagePercentage')
      .typeError('environment.errors.wastagePercentage')
      .min(0, 'environment.errors.wastagePercentage')
      .max(50, 'environment.errors.wastagePercentage')
  });
  return { validationSchema };
};

export default useFiltersValidationSchema;


